(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const PER_PAGE = 20;

  class OsFaq {
    constructor(section) {
      this.section       = section;
      this.allItems      = Array.from(section.querySelectorAll('.os-faq__item'));
      this.pills         = Array.from(section.querySelectorAll('.os-faq__pill'));
      this.searchInput   = section.querySelector('.os-faq__search');
      this.list          = section.querySelector('#os-faq-list');
      this.countEl       = section.querySelector('#os-faq-count');
      this.badgeEl       = section.querySelector('#os-faq-active-cat-label');
      this.emptyEl       = section.querySelector('#os-faq-empty');
      this.paginationEl  = section.querySelector('#os-faq-pagination');
      this.pageLabel     = section.querySelector('#os-faq-pagination-label');
      this.pageControls  = section.querySelector('#os-faq-page-controls');
      this.schemaScript  = document.getElementById('os-faq-schema');

      this.activeCategory = 'all';
      this.searchQuery    = '';
      this.currentPage    = 1;

      this._bindEvents();
      this._render();
    }

    /* ── Events ── */
    _bindEvents() {
      // Category pills
      this.pills.forEach(pill => {
        pill.addEventListener('click', () => {
          this.activeCategory = pill.dataset.category;
          this.currentPage    = 1;
          this.searchInput.value = '';
          this.searchQuery = '';

          this.pills.forEach(p => {
            p.classList.remove('os-faq__pill--active', 'os-faq__pill--selected');
            p.setAttribute('aria-selected', 'false');
          });

          if (this.activeCategory === 'all') {
            pill.classList.add('os-faq__pill--active');
          } else {
            pill.classList.add('os-faq__pill--selected');
          }
          pill.setAttribute('aria-selected', 'true');

          this._render();
        });
      });

      // Search — debounced
      let timer;
      this.searchInput.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.searchQuery    = this.searchInput.value.trim().toLowerCase();
          this.currentPage    = 1;
          this._render();
        }, 220);
      });
    }

    /* ── Filter ── */
    _filteredItems() {
      return this.allItems.filter(item => {
        const catMatch  = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
        const qMatch    = !this.searchQuery || item.dataset.question.includes(this.searchQuery)
                          || (item.querySelector('.os-faq__answer-inner') || {}).textContent?.toLowerCase().includes(this.searchQuery);
        return catMatch && qMatch;
      });
    }

    /* ── Render ── */
    _render() {
      const filtered   = this._filteredItems();
      const total      = filtered.length;
      const totalPages = Math.ceil(total / PER_PAGE) || 1;
      this.currentPage = Math.min(this.currentPage, totalPages);

      const start = (this.currentPage - 1) * PER_PAGE;
      const end   = start + PER_PAGE;
      const visible = filtered.slice(start, end);

      // Hide all, show visible
      this.allItems.forEach(item => { item.style.display = 'none'; });
      visible.forEach(item => { item.style.display = ''; });

      // Empty state
      const isEmpty = visible.length === 0;
      this.emptyEl.hidden = !isEmpty;

      // Results label
      const activePill = this.pills.find(p => p.getAttribute('aria-selected') === 'true');
      const catLabel = activePill ? activePill.textContent.trim() : '';
      this.badgeEl.textContent = catLabel !== 'All' ? catLabel : '';
      this.countEl.textContent = `${total} question${total !== 1 ? 's' : ''}`;

      // Pagination
      this._renderPagination(total, totalPages);

      // JSON-LD
      this._updateSchema(visible);
    }

    /* ── Pagination UI ── */
    _renderPagination(total, totalPages) {
      const start = (this.currentPage - 1) * PER_PAGE + 1;
      const end   = Math.min(this.currentPage * PER_PAGE, total);

      this.pageLabel.textContent = total > 0
        ? `Showing ${start}–${end} of ${total} question${total !== 1 ? 's' : ''}`
        : '';

      this.pageControls.innerHTML = '';
      if (totalPages <= 1) return;

      const make = (label, page, cls, disabled) => {
        const btn = document.createElement('button');
        btn.className = `os-faq__page-btn ${cls}`.trim();
        btn.textContent = label;
        btn.disabled = disabled;
        btn.setAttribute('aria-label', `Page ${page}`);
        if (!disabled) {
          btn.addEventListener('click', () => {
            this.currentPage = page;
            this._render();
            this.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        return btn;
      };

      // Prev
      this.pageControls.appendChild(
        make('← Prev', this.currentPage - 1, 'os-faq__page-btn--nav', this.currentPage === 1)
      );

      // Page numbers (show up to 5 with ellipsis)
      const pages = this._pageRange(totalPages);
      let lastNum = null;
      pages.forEach(p => {
        if (p === '…') {
          const el = document.createElement('span');
          el.className = 'os-faq__page-ellipsis';
          el.textContent = '…';
          this.pageControls.appendChild(el);
        } else {
          if (lastNum !== null && p - lastNum > 1) {
            const el = document.createElement('span');
            el.className = 'os-faq__page-ellipsis';
            el.textContent = '…';
            this.pageControls.appendChild(el);
          }
          const btn = make(p, p, p === this.currentPage ? 'os-faq__page-btn--active' : '', false);
          if (p === this.currentPage) btn.setAttribute('aria-current', 'page');
          this.pageControls.appendChild(btn);
          lastNum = p;
        }
      });

      // Next
      this.pageControls.appendChild(
        make('Next →', this.currentPage + 1, 'os-faq__page-btn--nav', this.currentPage === totalPages)
      );
    }

    _pageRange(total) {
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
      const c = this.currentPage;
      const pages = new Set([1, total, c]);
      if (c > 1) pages.add(c - 1);
      if (c < total) pages.add(c + 1);
      return Array.from(pages).sort((a, b) => a - b);
    }

    /* ── JSON-LD ── */
    _updateSchema(visibleItems) {
      const entity = visibleItems.slice(0, 20).map(item => ({
        '@type': 'Question',
        'name': item.querySelector('.os-faq__question-text')?.textContent?.trim() || '',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': item.querySelector('.os-faq__answer-inner')?.textContent?.trim() || ''
        }
      }));
      this.schemaScript.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': entity
      });
    }
  }

  /* ── Accordion toggle ── */
  document.addEventListener('click', e => {
    const toggle = e.target.closest('.os-faq__toggle');
    if (!toggle) return;

    const item    = toggle.closest('.os-faq__item');
    const answer  = item.querySelector('.os-faq__answer');
    const isOpen  = item.classList.contains('os-faq__item--open');

    // Close all in this section
    const section = toggle.closest('.os-faq');
    section.querySelectorAll('.os-faq__item--open').forEach(openItem => {
      openItem.classList.remove('os-faq__item--open');
      const btn = openItem.querySelector('.os-faq__toggle');
      const ans = openItem.querySelector('.os-faq__answer');
      btn.setAttribute('aria-expanded', 'false');
      ans.setAttribute('hidden', '');
    });

    // Toggle clicked item
    if (!isOpen) {
      item.classList.add('os-faq__item--open');
      toggle.setAttribute('aria-expanded', 'true');
      answer.removeAttribute('hidden');
    }
  });

  /* ── Init ── */
  document.querySelectorAll('.os-faq[data-section-id]').forEach(section => {
    new OsFaq(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault();
  });

  function readProductSettingsJSON(root) {
    if (!root) return null;
    const scripts = root.querySelectorAll('script[type="application/json"]');
    for (const s of scripts) {
      for (const attr of Array.from(s.attributes)) {
        if (attr.name.startsWith('data-product-settings-')) {
          return JSON.parse(s.textContent || '{}');
        }
      }
    }
    return null;
  }

  document.addEventListener('product-form:message:success', (event) => {
    const sectionEl = event.detail.form.closest('.shopify-section');
    const settings = readProductSettingsJSON(sectionEl) || {};
    if (settings && typeof settings.successMessage === 'string') {
      const title = event.detail.response?.title ?? event.detail.response?.product_title ?? '';
      event.detail.message = settings.successMessage.replace('** product **', title);
    }

    //console.log(event.detail);

    if (event.detail.cart && typeof event.detail.cart.item_count === 'number') {
      document.dispatchEvent(new CustomEvent('cart:count', { detail: { count: event.detail.cart.item_count } }));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
